import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FilingFormStateService } from '../services/mbrs/filing-form-state.service';
import { ConversionPhaseEnum } from '../../types/commons';

/**
 * Gate the /filing/role1 route behind "conversion has reached Phase 2".
 *
 * role1 (FilingInformation) is the Phase 2 editable filing-info surface.
 * During Phase 1 role0 (FilingPrerequisites) owns the editable state and
 * role1 is UI-filtered out of the sheet selector (see
 * filing-form-container.component.ts:~1435). A user URL-poking
 * /filing/role1 while still in Phase 1 would land on an empty / stale
 * surface because the filingInfo state slot is not the authoritative
 * source in Phase 1. This guard redirects them back to the filing-form
 * container, which will surface the correct Phase 1 or Phase 2 sheet.
 *
 * Phase is reported by the backend's retrieve-mbrs-data response and
 * stored on FilingFormStateService via setConversionPhase(). Before the
 * backend reports, the phase is null — treat that as "not yet Phase 2"
 * and redirect. The user will land at /mbrs/filing which triggers the
 * fetch, and once phase is known they can navigate back if appropriate.
 */
export const isPhase2Guard: CanActivateFn = () => {
  const stateService = inject(FilingFormStateService);
  const router = inject(Router);

  if (stateService.getConversionPhase() === ConversionPhaseEnum.Phase2) {
    return true;
  }

  router.navigate(['/mbrs/filing']);
  return false;
};
